import { atom, selector } from "recoil";
import { contractConfigState } from "./ContractConfigState";

export const mapRegionState = atom({
  key: 'mapRegionState',
  default: selector({
    key: 'mapRegionStateSelector',
    get: ({get}) => {
      const {mapRegion} = get(contractConfigState)
      return mapRegion;
    }
  })
});
